import { Stages } from 'utils/enum'
import { QuoteProps } from '../type'
import { ServicesFormBase } from './ServiceFormBase'

export const ServicesForm = (props: QuoteProps) => {
  return <ServicesFormBase props={props} stage={Stages.STAGE3} />
}
